import { useCallback } from 'react';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { locations } from 'services/routes/locations';
import { selectReleases } from 'services/store/distribution/selectors';
import { selectArtists } from 'services/store/user/selectors';

const useReleaseNavigation = () => {
  const navigate = useNavigate();

  const releases = useSelector(selectReleases);
  const artists = useSelector(selectArtists);

  const navigateToRelease = useCallback(
    (releaseId: string) => {
      const release = releases[releaseId];

      if (!release) {
        return;
      }

      if (!artists.length) {
        return navigate(locations.distribution.artistName.pathname(release.id));
      }

      return navigate(locations.distribution.tracklist.pathname(release.id));
    },
    [releases, artists, navigate]
  );

  return navigateToRelease;
};

export default useReleaseNavigation;
